import UserDto from "@/interfaces/IUserDto";
import axios from "axios";
import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
	state: () => ({
		user: null as null|UserDto
	}),

	getters: {
		isSuper() : boolean {
			if (this.user == null) {
				return false;
			}

			return (this.user.isSuper);
		}
	},

	actions: {
		async getCurrentUser() {
			try {
				const userResponse = await axios.get<UserDto>("Users/Me");
				this.user = userResponse.data;

			} catch(ex:unknown) {
				console.log("getCurrentUser failed");
				this.user = null;
			}
		},
		async logout() {
			try {
				const logoutResponse = await axios.get<boolean>("Users/logout");
				console.log(logoutResponse.data);
			} catch (error) {
				console.log("Logout failed")
				this.user = null;
			}
		}
	}
});